<template>
  <section class="bg-black">
    <!-- this is background -->

    <div class="parallax-contact relative" data-aos="fade"></div>
    <div class="parallax-text"></div>

    <!-- this is the image on top -->

    <div class="w-full bg-black overflow-hidden">
      <div class="contact-page-container">
        <div class="w-full bg-black -mt-2">
          <h1 class="text-white my-12 py-8 text-4xl">
            CONTACT <br class="hidden" />
            US
          </h1>
          <div class="flex flex-row sm:flex-col">
            <div class="w-7/12 sm:w-screen sm:order-2">
              <contact-us-form></contact-us-form>
            </div>
            <div class="w-5/12 sm:w-screen sm:order-first">
              <p class="text-white m-auto w-9/12 sm:float-left sm:w-4/5">
                A Shogun is loyal to its country, as we are loyal to our
                customers, please always leave us a comment and let us
                understand you better.
              </p>

              <p class="youkoso m-auto w-9/12 text-2xl sm:float-left pt-20" data-aos="fade-left">
                Y O U K O S O !
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- this is the contact form -->
  </section>
</template>

<script>
import ContactUsForm from "../components/ContactUsForm";
export default {
  components: {
    ContactUsForm
  }
};
</script>

<style scoped>
.parallax-contact {
  /* The image used */
  background-image: url("~@/assets/images/store-front.png");

  /* Set a specific height */
  min-height: 120vh;

  /* Create the parallax scrolling effect */
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  margin-top: -200px;
}

@media only screen and (max-width:639px)
{
.parallax-contact {
background-attachment: unset;
  background-size: auto;
}
}

.contact-page-container {
  max-width: 80%;

  margin: auto;
}
.youkoso {
  position: relative;
  height: auto;
  font-family: Times;
  font-style: normal;
  font-weight: normal;

  /* or 100% */

  letter-spacing: 0.2em;
  text-transform: uppercase;

  color: #c7272b;
}
</style>